import React, { FC } from "react";
import Button from "../../../../components/general/buttons/Button/Button";
import IconFont from "../../../../components/general/icons/IconFont/IconFont";
import NotificationsBlock from "../../../../components/layout/NotificationsBlock/NotificationsBlock";
import { useAppDispatch } from "../../../../store/hooks/dispatch.hook";
import { changeNotificationsStatusFetch, NotificationStatuses } from "../../../../store/state/notifications/notifications.slice";
import { Notification as NotificationType } from "../../../../store/state/notifications/models/Notification";
import { DateApi } from "../../../../services/Date/Date";
import { TYPES } from "../../../../common/constants/types";
import Notification from "../../../../components/feedback/notifications/Notification/Notification";
import Paragraph from "../../../../components/general/typography/Paragraph/Paragraph";

interface Props {
    vendorId: number;
    archive: NotificationType[];
}

const NotificationsArchive: FC<Props> = ({ vendorId, archive }) => {
    const dispatch = useAppDispatch();

    const notifications = archive.map((notification, index) => {
        let marginBottom = 15;
        const message = notification.message;
        const datetime = DateApi.parseDateTime(notification.date);
        const date = `${DateApi.parseDateStringPrint(datetime[0])} ${datetime[1]}`;
        const origin = notification.typeId === TYPES.SYSTEM ? "Система" : "Клієнти";

        const prevStatusId = notification.statusId;
        const notificationsIds = [notification.id];

        const clickActiveButtonHandler = () => {
            dispatch(changeNotificationsStatusFetch({ 
                vendorId, 
                statusId: NotificationStatuses.ACTIVE, 
                prevStatusId, 
                notificationsIds 
            }));
        }

        const clickSelectButtonHandler = () => {
            dispatch(changeNotificationsStatusFetch({ 
                vendorId, 
                statusId: NotificationStatuses.SELECTED, 
                prevStatusId, 
                notificationsIds 
            }));
        }

        return (
            <Notification
                marginBottom={marginBottom}
                notification={<Paragraph content={message} />}
                datatime={date}
                origin={origin}
                icon={<></>}
                active={true}
                clickActiveButtonHandler={clickActiveButtonHandler}
                clickSelectButtonHandler={clickSelectButtonHandler}
            />
        );
    });

    return (
        notifications.length > 0 ?
            <NotificationsBlock title="Архівні">
                {notifications}
            </NotificationsBlock>
            :
            <></>
    );
}

export default NotificationsArchive;